export { ChassisCommentsModule } from './src/app/comments.module';
export { ChassisCommentsModule as CommentsModule } from './src/app/comments.module';
export { CommentRelationPlugin } from './src/app/plugins/comment-relation/comment-relation.plugin';
export { CommentService } from './src/app/services/comment.service';
export { RelationCommentService } from './src/app/services/relation-comment.service';
export { CommentModel } from './src/app/models/comment.model';
export { CommentableInterface } from './src/app/interfaces/commentable.interface';



// WEBPACK FOOTER //
// ./libs/chassis-comments/index.ts